<mat-toolbar color="secondary">
  @if (isProtected) {
    <div
      matTooltip="{{ showToolTip()? ('DOCUMENT.PROTECTEDBYWEBDOKU' | translate):'' }}"
      ><mat-icon class="lock-icon">lock_outlined</mat-icon></div>
    }
    <ldw-document-title [document]="document" class='title'></ldw-document-title>
    <span class="spacer"></span>
    <ldw-document-images [document]="document"></ldw-document-images>

    @if (hasStatusLabel || hasStatusChange) {
      <ldw-status-label [status]="currentStatus"></ldw-status-label>
    }

    <div class="buttons">
      <button mat-icon-button [matMenuTriggerFor]="infoMenu" >
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-menu #infoMenu="matMenu" yPosition="below">
    <button mat-menu-item (click)="close()">
      <mat-icon>close</mat-icon>
      <span>{{'DIALOGS.CLOSE'|translate}}</span>
    </button>
    @if (isEditButtonAllowed) {
      <button mat-menu-item (click)="editDocument()">
        <mat-icon>edit</mat-icon>
        <span>{{'DIALOGS.EDIT'|translate}}</span>
      </button>
    }
    @if (hasStatusChange) {
      <button mat-menu-item (click)="editStatus()">
        <mat-icon>unfold_more</mat-icon>
        <span>{{'DOCUMENT.CHANGESTATUS'|translate}}</span>
      </button>
    }
    @if (isBookmarkButtonAllowed) {
      <button mat-menu-item (click)="addToBookmark()">
        <mat-icon>bookmark</mat-icon>
        <span>{{'DOCUMENT.ADDTOBOOKMARK'|translate}}</span>
      </button>
    }
    <mat-divider></mat-divider>
    @if (isDeleteAllowed) {
      <div>
        <button mat-menu-item (click)="deleteDocument()">
          <mat-icon>delete</mat-icon>
          <span>{{'DIALOGS.DELETE' | translate}}</span></button>
          <mat-divider></mat-divider>
        </div>
      }
      @if (isCopyAllowed) {
        <div>
          <button mat-menu-item (click)="copyDocument()">
            <mat-icon>output</mat-icon>
            <span>{{'DIALOGS.COPY' | translate}}</span></button>
            <mat-divider></mat-divider>
          </div>
        }
        <button mat-menu-item (click)="showChanges()">
          <mat-icon>change_circle</mat-icon>
          <span>{{'DOCUMENT.CHANGES' | translate}}</span></button>
          <button mat-menu-item (click)="showInfo()">
            <mat-icon>info</mat-icon>
            <span>{{'DOCUMENT.INFO' | translate}}</span></button>
            @if (isHistoryButtonAllowed) {
              <button mat-menu-item  (click)="showHistory()">
                <mat-icon>history</mat-icon>
                <span>{{'DOCUMENT.HISTORY' | translate}}</span></button>
              }
            </mat-menu>
